import { render, staticRenderFns } from "./WfHistory.vue?vue&type=template&id=30750f00&scoped=true&"
import script from "./WfHistory.vue?vue&type=script&lang=js&"
export * from "./WfHistory.vue?vue&type=script&lang=js&"
import style0 from "./WfHistory.vue?vue&type=style&index=0&id=30750f00&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30750f00",
  null
  
)

export default component.exports